(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/lobby/game.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/lobby/game.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  checkLoggedIn
} = svs.eInstant.util;
setGlobal('svs.eInstant.lobby.onLinkClicked', (url, isDemo) => {
  const returnUrl = svs.core.data.baseUrl + url;
  const isWillNavigate = checkLoggedIn(isDemo, returnUrl);
  if (isWillNavigate) {
    window.location.href = returnUrl;
  }
});
const OverlayLoader = _ref => {
  let {
    url
  } = _ref;
  const {
    useContext
  } = React;
  const {
    Loader
  } = svs.components.ReactLoader;
  const {
    state = {}
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const loadingInfoImages = state.gameUrl === url && state.loadingInfoImages;
  return loadingInfoImages ? React.createElement(Loader, {
    className: "e-instant-lobby-game"
  }) : null;
};
const Overlay = _ref2 => {
  let {
    infoUrl,
    name,
    demoUrl,
    playUrl,
    listIndex,
    minPrice,
    trackingName,
    url,
    seoTitle
  } = _ref2;
  const {
    useCallback,
    useContext
  } = React;
  const {
    dispatch
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const {
    GAME_URL
  } = svs.eInstant.lobby.actions;
  const {
    useHistory
  } = ReactRouterDOM;
  const {
    onPlay
  } = svs.eInstant.util;
  const history = useHistory();
  const {
    ReactButton: Button,
    ReactIconButton: IconButton,
    ReactIcon: Icon
  } = svs.ui;
  const isDesktop = svs.core.detect.formfactor.desktop();
  const onInfoClicked = useCallback((e, gameUrl) => {
    e === null || e === void 0 || e.preventDefault();
    window.history.replaceState(null, '', "".concat(svs.core.data.baseUrl).concat(gameUrl));
    document.title = seoTitle || name;
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: url
      }
    });
  }, []);
  return isDesktop && React.createElement("div", {
    className: "e-instant-lobby-game-overlay-container"
  }, React.createElement("div", {
    className: "e-instant-lobby-game-overlay"
  }, React.createElement(IconButton, {
    className: "e-instant-lobby-game-overlay-icon fc-white",
    "data-index": listIndex,
    "data-testid": "info-button-".concat(listIndex),
    "data-url": infoUrl,
    icon: "information",
    onClick: e => onInfoClicked(e, infoUrl),
    tabIndex: "-1",
    title: "Mer info om ".concat(name)
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "information"
  })), React.createElement("div", {
    className: "e-instant-lobby-game-overlay-actions"
  }, React.createElement("h2", {
    className: "fc-white f-800 col-xs-12 e-instant-lobby-game-overlay-name"
  }, name), React.createElement(Button, {
    className: "e-instant-lobby-game-overlay-action",
    "data-index": listIndex,
    "data-minprice": minPrice,
    "data-name": name,
    "data-playtype": "play",
    "data-testid": "play-button-".concat(listIndex),
    "data-track": trackingName,
    href: playUrl,
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onPlay(e, history, () => {
        svs.eInstant.lobby.onLinkClicked(playUrl, false);
      });
    },
    size: 300,
    tabIndex: "-1",
    title: "Spela"
  }, "Spela"), React.createElement(Button, {
    className: "e-instant-lobby-game-overlay-action",
    "data-index": listIndex,
    "data-minprice": minPrice,
    "data-name": name,
    "data-playtype": "demo",
    "data-testid": "demo-button-".concat(listIndex),
    "data-track": trackingName,
    href: demoUrl,
    inverted: true,
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onPlay(e, history, () => {
        svs.eInstant.lobby.onLinkClicked(demoUrl, true);
      });
    },
    size: 300,
    tabIndex: "-1",
    title: "Provspela",
    transparent: true
  }, "Provspela"), React.createElement("a", {
    className: "fc-white f-400 e-instant-lobby-game-overlay-pause e-instant-pause24 js-pause24-trigger block margin-top-1",
    tabIndex: "-1"
  }, "SPELPAUS24"))));
};
const GameInfo = _ref3 => {
  let {
    minPrice,
    maxPrice,
    legalNotice,
    maxWin
  } = _ref3;
  const prices = minPrice + (maxPrice && "-".concat(maxPrice));
  return React.createElement("div", {
    className: "e-instant-lobby-game-money f-bold fc-fler-lotter-200"
  }, React.createElement("div", {
    className: "col-xs-6"
  }, "".concat(prices, " kr")), React.createElement("div", {
    className: "col-xs-6 align-right"
  }, "".concat(svs.utils.format.Currency(maxWin), " kr")), legalNotice && React.createElement("div", {
    className: "col-xs-12 fc-white e-instant-lobby-legal"
  }, legalNotice));
};
const Image = _ref4 => {
  let {
    image
  } = _ref4;
  const {
    Image
  } = svs.content.image_v2;
  return React.createElement("div", {
    className: "e-instant-lobby-game-img"
  }, image ? React.createElement(Image, {
    image: _objectSpread(_objectSpread({}, image), {}, {
      loadingLazy: true
    })
  }) : React.createElement("div", null));
};
const ImageMemo = React.memo(Image);
const Link = _ref5 => {
  let {
    infoUrl,
    name,
    trackingName,
    listIndex,
    url,
    children
  } = _ref5;
  const {
    useContext
  } = React;
  const {
    dispatch
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const {
    GAME_URL
  } = svs.eInstant.lobby.actions;
  const isDesktop = svs.core.detect.formfactor.desktop();
  const onInfoClicked = (e, infoUrl) => {
    const {
      track,
      index = 0
    } = e.currentTarget.dataset;
    !isDesktop && svs.components.analytics.trackPromoClick({
      ID: track,
      name: track,
      position: parseInt(index, 10)
    });
    window.history.replaceState(null, '', "".concat(svs.core.data.baseUrl).concat(infoUrl));
    document.title = "".concat(name);
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: url
      }
    });
  };
  return React.createElement("a", {
    className: "e-instant-lobby-game-link",
    "data-area-name": "lobby-".concat(listIndex),
    "data-impression": "true",
    "data-index": listIndex,
    "data-name": name,
    "data-testid": "play-button-mobile-".concat(listIndex),
    "data-track": trackingName,
    "data-url": url,
    href: infoUrl,
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onInfoClicked(e, infoUrl);
    },
    title: name
  }, children);
};
const Ribbon = _ref6 => {
  let {
    badge
  } = _ref6;
  const {
    RibbonCorner
  } = svs.ui.ReactRibbon;
  return badge && React.createElement("div", {
    className: "e-instant-ribbon-container"
  }, React.createElement(RibbonCorner, {
    size: 500
  }, badge));
};
const Game = props => React.createElement("div", {
  className: "e-instant-lobby-game"
}, React.createElement(Ribbon, props), React.createElement(Link, props, React.createElement(ImageMemo, props), React.createElement(GameInfo, props)), React.createElement(OverlayLoader, props), React.createElement(Overlay, props));
setGlobal('svs.eInstant.lobby.Game', Game);

 })(window);